import { render } from "./AddCampagnePage.vue?vue&type=template&id=7468b376&ts=true"
import script from "./AddCampagnePage.vue?vue&type=script&lang=ts"
export * from "./AddCampagnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__